

@if (isLoading) {
  <div class="main-graph-child skeleton-main skeleton">
    <div class="payroll-subcomponent">
      <div class="common-head">
        <div class="skeleton-box title"></div>
        <div class="skeleton-box tab-buttons"></div>
      </div>

      <div class="comon-subhead">
        <div class="skeleton-circle"></div>
        <div class="skeleton-box salary-info"></div>
      </div>

      <div class="skeleton-chart"></div>
    </div>

    <div class="pie-graph-section">
      <div class="common-head">
        <div class="skeleton-box title"></div>
        <div class="skeleton-box date"></div>
      </div>

      <div class="salary-total-cal">
        <div class="skeleton-card small"></div>
        <div class="skeleton-card small"></div>
        <div class="skeleton-card small"></div>
      </div>

      <div class="skeleton-pie"></div>
    </div>
  </div>
}

<!-- ✅ Actual content (after data is loaded) -->
@else {
<div class="main-graph-child">
    <div class="payroll-subcomponent">
        <div class="common-head">
            <div class="comon-left-head">
                <h1>Payroll Summary</h1>
                <div class="tabs-button">
                    <button [class.active]="selectedTab === 'monthly'" (click)="selectTab('monthly')">Monthly</button>
                    <button [class.active]="selectedTab === 'yearly'" (click)="selectTab('yearly')">Yearly</button>
                </div>

            </div>
            <div class="comon-right">
                <div class="form-group custom-select-wrapper">
                 <select class="form-control custom-select" [(ngModel)]="selectedYear" (ngModelChange)="onYearChange($event)">
                    <option [ngValue]="null" disabled>Select Year</option>
                    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                    </select>


                    <span class="custom-arrow">
                        <i class="fa fa-chevron-down"></i>
                    </span>
                    </div>

            </div>
        </div>
        <div class="comon-subhead">
            <div class="total-pay-img">
                <img src="../../../../assets/theme1/pay-img.png" alt="missing" />
            </div>
            <div class="comon-pay-detail">
                <p>Total earning ({{salarySummary?.duration || 'No Data Found'}})  <img (click)="sendFalse()" style="cursor:pointer;"
                        src="../../../../assets/login/eye.png" alt="missing" /> </p>
                <h1> 
                  {{ isStar ? '*****/- PKR' : salarySummary.totalEarning  }}
                    
                    <span>/- PKR</span></h1>
            </div>
        </div>

        <div class="pay-chart" id="chart">
            <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
                [yaxis]="chartOptions.yaxis" [stroke]="chartOptions.stroke" [fill]="chartOptions.fill"
                [tooltip]="chartOptions.tooltip" [legend]="chartOptions.legend" [grid]="chartOptions.grid"
                [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions!">
            </apx-chart>
        </div>

    </div>

    <div class="pie-graph-section">

        <div class="common-head">
            <div class="comon-left-head border-reduce">
                <h1>Payroll Allocation</h1>
            </div>
            <div class="comon-right allocation-date">
                <p>{{salarySummary?.duration || 'No Data Found'}}</p>
            </div>
        </div>
        <div class="salary-total-cal">
            <div class="comon-card total-earn">
                <p>Total Earning</p>
                <h1>{{ isStar ? '*****/- PKR' : salarySummary.totalSalary  }}<span>/- PKR</span></h1>
            </div>
            <div class="comon-card total-deduct">
                <p>Total Deduction</p>
                <h1>{{ isStar ? '*****/- PKR' : salarySummary.totalDeduction  }}<span>/- PKR</span></h1>
            </div>
            <div class="comon-card total-tax">
                <p>Total Tax</p>
                <h1>{{ isStar ? '*****/- PKR' : salarySummary.totalTax  }}<span>/- PKR</span></h1>
            </div>
        </div>
        <div id="payroll-allocation-chart">
            <apx-chart #allocationChart [series]="allocationChartOptions?.series"
                [chart]="allocationChartOptions?.chart" [labels]="allocationChartOptions?.labels"
                [fill]="allocationChartOptions?.fill" [stroke]="allocationChartOptions?.stroke"
                [tooltip]="allocationChartOptions?.tooltip" [legend]="allocationChartOptions?.legend"
                [responsive]="allocationChartOptions?.responsive"></apx-chart>
        </div>
    </div>

</div>


}